import React from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MixpanelService from "../utils/MixpanelService";
import INTERCOM_ARTICLES from "../../constants/intercomArticles";

const SubmissionModal = ({ organizationId, handleCloseModal }) => {
  return createPortal(
    <div className="modal__background" onClick={handleCloseModal}>
      <div className="submission_modal__container" onClick={(e) => e.stopPropagation()}>
        <div className="submission_modal__right">
          <div className="submission_modal__title">
            Start a Submission
            <CloseIcon onClick={handleCloseModal} />
          </div>
          <div className="submission_modal__subtitle">
            Choose the type of submission you would like to make.
          </div>
          <div className="submission_modal__options">
            <a
              href={`/organization/${organizationId}/pharmacy_submissions/new`}
              onClick={() =>
                MixpanelService.track("esp_submissions_card_pharmacy_submission_clicked")
              }
              className="submission_modal__button"
            >
              <div className="submission_modal__option_title">Pharmacy Claims</div>
              <div className="submission_modal__option_subtitle">
                A pharmacy claim for subsequent self-administration by the patient.
              </div>
            </a>
            <a
              href={`/organization/${organizationId}/pharmacy_encounter_submissions/new`}
              onClick={() =>
                MixpanelService.track("esp_submissions_card_pharmacy_encounter_submission_clicked")
              }
              className="submission_modal__button"
            >
              <div className="submission_modal__option_title">
                Pharmacy Claims with Encounter Data
              </div>
              <div className="submission_modal__option_subtitle">
                A pharmacy claim appended with standard health visit and service claims data fields.
                The appended data provides anonymized information about the healthcare encounter
                that resulted in the 340B dispense.
              </div>
            </a>
            <a
              href={`/organization/${organizationId}/medical_submissions/new`}
              onClick={() =>
                MixpanelService.track("esp_submissions_card_medical_submission_clicked")
              }
              className="submission_modal__button"
            >
              <div className="submission_modal__option_title">Medical Claims</div>
              <div className="submission_modal__option_subtitle">
                A medical claim is a healthcare claim originating from a prescriber's outpatient
                medication administration to a patient.
              </div>
            </a>
            <a
              href={`/organization/${organizationId}/medical_encounter_submissions/new`}
              onClick={() =>
                MixpanelService.track("esp_submissions_card_medical_encounter_submission_clicked")
              }
              className="submission_modal__button"
            >
              <div className="submission_modal__option_title">
                Medical Claims with Encounter Data
              </div>
              <div className="submission_modal__option_subtitle">
                A medical claim appended with standard health visit and service claims data fields.
                The appended data provides anonymized information about the healthcare encounter
                that resulted in the 340B administration.
              </div>
            </a>
          </div>
          <div className="submission_modal__choose">
            <div className="submission_modal__choose_icon">
              <HelpOutlineIcon />
            </div>
            <div className="submission_modal__choose_text">
              <a href={INTERCOM_ARTICLES.WHICH_SUBMISSION_TYPE_TO_CHOOSE} target="_blank">
                Which one should I choose?
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SubmissionModal;
